'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noOp = function noOp() {};

var defaultProps = {
  aspectRatio: 'inherit',
  file: '',
  isAutoPlay: false,
  isMuted: false,
  onAdPlay: noOp,
  onAdResume: noOp,
  onEnterFullScreen: noOp,
  onExitFullScreen: noOp,
  onMute: noOp,
  onUnmute: noOp,
  onAutoStart: noOp,
  onResume: noOp,
  onPlay: noOp,
  onClose: noOp,
  onReady: noOp,
  onError: noOp,
  onAdPause: noOp,
  onPause: noOp,
  onVideoLoad: noOp,
  onOneHundredPercent: noOp,
  onThreeSeconds: noOp,
  onTenSeconds: noOp,
  onThirtySeconds: noOp,
  onFiftyPercent: noOp,
  onNinetyFivePercent: noOp,
  playlist: ''
};

exports.default = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jw-player/dist/default-props.js
// module id = 678
// module chunks = 0